import _ from "lodash";
import store from "CommonState/store";
import {
  Component,
} from "react";
import {
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import {
  Panel,
  Spinner,
} from "CommonComponents/bricks";
import {
  Link,
} from "react-router-dom";
import {
  withLocation,
} from "CommonCore/router-util";
import {
  formatAntrag,
} from "Apis/massnahme-api";

import antragApi, {
  antragParams,
} from "Apis/antrag-api";
import {
  ANTRAGSTELLERMODUS,
} from "../constants";

@store("k_einrichtungLookup", "k_antragtypLookup", "k_vertragsartLookup", "k_antragstatusLookup")
@withLocation
export class AntragItem extends Component {
  // Maßnahme für die Anzeige formatieren
  render() {
    const { antrag } = this.props;
    return <ListGroupItem><Link to={`/antrag/${ antrag.a_id }`}>{formatAntrag(antrag, this.props)}</Link> </ListGroupItem>;
  }
}

@antragApi.list(antragParams("0"))
@antragApi.uiList
export default class DashboardWidgetAnträge extends Component {
  constructor() {
    super();
  }

  render() {
    const { antragList: data, AntragstellerModus } = this.props;
    if (!data) {
      return <Spinner />;
    }

    const antragList = ANTRAGSTELLERMODUS[AntragstellerModus].filterAnträge(data, true); // nur aktive Anträge

    return <Panel>
      <h3>Laufende Anträge</h3>
      <br />
      {_.isEmpty(antragList)
? <span><br />(aktuell keine vorhanden)</span>
: <span><br />
  <ListGroup> {_.map(antragList, item => <AntragItem key={item.a_id} antrag={item} />)}</ListGroup>
</span>
      }
    </Panel>;
  }
}

